<!--
------------------------------------------------------------------------------
-- 'ShpSnackbar'
------------------------------------------------------------------------------
------------------------------------------------------------------------------
-- Autor                 -- fecha       -- versión  -- cambios
------------------------------------------------------------------------------
-- Ivan Ferrando        18/09/2019        1.1       Creación
------------------------------------------------------------------------------
-- Resumen: modal que te indica un texto durante un tiempo
-- 
-- Importante: Tener instalado el BUS, mdi-icons
--
-- Propiedades:
--   text -- String -- Requerido -- texto del contenido de la modal
--   value  -- Boolean -- Requerido -- levanta y cierra la modal
--   type -- String -- ['success', 'info', 'error'] sirve para sacar un color u otro según el tipo
--   time -- Number -- tiempo que muestra el snackbar
--   data -- String -- Datos adicionales
------------------------------------------------------------------------------
-->
<template>
  <v-snackbar v-model="showSnackbar" bottom multi-line :right="dScreenWidth > 600" :timeout="timeSnackbar"
    :color="typeSnackbar + 'Alert'">
    <v-layout v-if="productSnackbar" row wrap align-center justify-space-around fill-height>
      <v-flex xs12 class="mb-2">
        <v-layout row wrap align-center>
          <v-flex shrink>
            <v-icon>mdi-cart-plus</v-icon>
          </v-flex>
          <v-flex grow class="alertTitle mb-1 pl-2">
            {{ $t('snackbar.addProduct') }}
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs3 mb-3 class="imgBlock">
        <v-img
          :src="productSnackbar.images != null && productSnackbar.images.length > 0 ? productSnackbar.images[0].link : '../../../static/style/base/img/noimg.png'"
          cover></v-img>
      </v-flex>
      <v-flex xs8>
        <p class="productName mb-1" v-if="productSnackbar.description">{{ productSnackbar.description }}</p>
        <p v-if="((!cShopMode && (cPriceKind === 1 || cPriceKind === 3)) || (this.cShopMode)) && productSnackbar.itemPrice != null"
          class="moreInfo">{{ productSnackbar.itemPrice.quantity }} x {{ new Intl.NumberFormat("de-DE", {
            style: "currency",
            currency: "EUR"
          }).format(fRedondearDecimales(productSnackbar.itemPrice.finalPriceImp)) }}</p>
        <p v-else-if="((!cShopMode && cPriceKind === 1) || (cShopMode)) && productSnackbar.itemPrice != null"
          class="moreInfo">{{ productSnackbar.itemPrice.quantity }} x {{ new Intl.NumberFormat("de-DE", {
            style: "currency",
            currency: "EUR"
          }).format(fRedondearDecimales(productSnackbar.itemPrice.finalPrice)) }}</p>
      </v-flex>
    </v-layout>

    <v-layout v-else row wrap align-center justify-space-around>
      <v-flex shrink px-1>
        <v-icon v-if="typeSnackbar === 'success'">mdi-check-circle-outline</v-icon>
        <v-icon v-else-if="typeSnackbar === 'info'">mdi-information-outline</v-icon>
        <v-icon v-else-if="typeSnackbar === 'error'">mdi-alert-circle-outline</v-icon>
      </v-flex>
      <v-flex class="px-1" :class="dataSnackbar.length > 0 ? 'xs9' : 'xs10'">{{ textSnackbar }}</v-flex>
      <v-flex v-if="dataSnackbar" shrink class="px-1 ml-auto">
        <v-btn dark icon flat @click="showDataSnackbar = !showDataSnackbar" class="mx-0"
          :aria-label="$t('btn.moreInfo')">
          <v-icon>
            mdi-information
          </v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs-12 v-if="showDataSnackbar" class="snackbarData py-1 px-2">
        <span>{{ dataSnackbar }}</span>
      </v-flex>
    </v-layout>

  </v-snackbar>
</template>

<script>


export default {

  data() {
    return {
      showSnackbar: false,
      showDataSnackbar: false,
      textSnackbar: '',
      typeSnackbar: 'success',
      timeSnackbar: 3000,
      dataSnackbar: '',
      productSnackbar: {},
      dScreenWidth: screen.width,
      resolveSnackbar: null,
    }
  },
  mounted() {
    this.$bus.$on('showSnackbar', snackbar => {
      this.textSnackbar = snackbar.text ? snackbar.text : ''
      this.dataSnackbar = snackbar.data ? snackbar.data : ''
      this.typeSnackbar = snackbar.type ? snackbar.type : 'success'
      this.timeSnackbar =
        typeof snackbar.time === 'number' ? snackbar.time : 3000
      this.showDataSnackbar = false
      this.showSnackbar = true
      this.productSnackbar = snackbar.productSelected ? snackbar.productSelected : ''
      this.resolveSnackbar = snackbar.resolve
    })
  },
  beforeDestroy() {
    this.$bus.$off('showSnackbar')
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Alerts/ShpSnackbar.vue